(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-review-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fp-review-carousel')) {
  customElements.define('fp-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.codex-review-gallery__track');
      this.cards = [...this.querySelectorAll('.codex-review-gallery__card')];
      this.dots = [...this.querySelectorAll('[data-review-index]')];
      if (!this.track || !this.cards.length) return;
      this.classList.add('is-ready');
      this.querySelector('.codex-review-gallery__arrows').hidden = false;
      this.querySelector('.codex-review-gallery__footer').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(this.nearest() - 1), { signal });
      this.querySelector('[data-next]').addEventListener('click', () => this.move(this.nearest() + 1), { signal });
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.move(index), { signal }));
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const actions = { ArrowLeft: this.nearest() - 1, ArrowRight: this.nearest() + 1, Home: 0, End: this.cards.length - 1 };
        if (event.key in actions) { event.preventDefault(); this.move(actions[event.key]); }
      }, { signal });
      this.querySelectorAll('.codex-review-gallery__more').forEach(button => {
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          button.querySelector('span').textContent = expanded ? button.dataset.less : button.dataset.more;
          document.getElementById(button.getAttribute('aria-controls')).classList.toggle('is-expanded', expanded);
        }, { signal });
      });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }, { signal, passive: true });
      this.resize = new ResizeObserver(() => { this.measure(); this.update(); });
      this.resize.observe(this.track);
      document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      this.measure();
      this.update();
    }
    positions() {
      const first = this.cards[0].getBoundingClientRect().left;
      const max = this.track.scrollWidth - this.track.clientWidth;
      return this.cards.map(card => Math.min(max, card.getBoundingClientRect().left - first));
    }
    nearest() {
      const positions = this.positions();
      return positions.reduce((best, value, index) => Math.abs(value - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft) ? index : best, 0);
    }
    move(index) {
      const target = Math.max(0, Math.min(this.cards.length - 1, index));
      this.track.scrollTo({ left: this.positions()[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    measure() {
      this.querySelectorAll('.codex-review-gallery__more').forEach(button => {
        const text = document.getElementById(button.getAttribute('aria-controls'));
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.hidden = !expanded && text.scrollHeight <= text.clientHeight + 1;
      });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const end = this.track.scrollLeft >= max - 2;
      const index = end ? this.cards.length - 1 : this.nearest();
      this.querySelector('[data-previous]').disabled = this.track.scrollLeft <= 2;
      this.querySelector('[data-next]').disabled = end;
      this.dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      this.querySelector('[data-position]').textContent = this.querySelector('[data-position-template]').content.textContent.replace('[number]', String(index + 1));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
